import { z } from 'zod';

export const groupItem = z.object({
  id: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean().optional(),
  name: z.string(),
  groupId: z.string().optional(),
  parentGroupItemId: z.string().optional(),
  rootCode: z.string().optional(),
  level: z.number().optional(),
  sequence: z.number().optional(),
  mwAccountGroupId: z.string().optional(),
});

export const getGroupItemsByGroupSchema = z.array(groupItem);

export type GetGroupItemsByGroupResponse = z.infer<typeof getGroupItemsByGroupSchema>;
